export const ADMIN = {
  REQUEST_USER_ROLES: 'admin/request_user_roles',
  RECEIVE_USER_ROLES: 'admin/receive_user_roles',
  RECEIVE_USER_ROLES_ERROR: 'admin/receive_user_roles_error',
  REQUEST_CAMPAIGNS: 'admin/request_campaigns',
  RECEIVE_CAMPAIGNS: 'admin/receive_campaigns',
  RECEIVE_CAMPAIGNS_ERROR: 'admin/receive_campaigns_error',
  REQUEST_PRODUCTS: 'admin/request_products',
  RECEIVE_PRODUCTS: 'admin/receive_products',
  RECEIVE_PRODUCTS_ERROR: 'admin/receive_products_error',
  REQUEST_UPDATE_PRODUCTS: 'admin/request_update_products',
  RECEIVE_UPDATED_PRODUCTS: 'admin/recieve_updated_products',
  RECEIVE_UPDATED_PRODUCTS_ERROR: 'admin/recieve_updated_products_error',
  REQUEST_ALL_CATEGORIES: 'admin/request_all_categories',
  RECEIVE_ALL_CATEGORIES: 'admin/receive_all_categories',
  RECEIVE_ALL_CATEGORIES_ERROR: 'admin/receive_all_categories_error',
  REQUEST_CATEGORIES_CAMPAIGN: 'admin/request_categories_campaign',
  RECEIVE_CATEGORIES_CAMPAIGN: 'admin/receive_categories_campaign',
  RECEIVE_CATEGORIES_CAMPAIGN_ERROR: 'admin/receive_categories_campaign_error',
  REQUEST_UPDATE_CATEGORIES: 'admin/request_update_categories',
  RECEIVE_UPDATED_CATEGORIES: 'admin/recieve_updated_categories',
  RECEIVE_UPDATED_CATEGORIES_ERROR: 'admin/recieve_updated_categories_error',
};

export type RequestUserRolesAction = {
  type: typeof ADMIN.REQUEST_USER_ROLES,
};

export type ReceiveUserRolesAction = {
  type: typeof ADMIN.RECEIVE_USER_ROLES,
  roles: Array,
};

export type ReceiveUserRolesErrorAction = {
  type: typeof ADMIN.RECEIVE_USER_ROLES_ERROR,
  error: string,
};

export type RequestCampaignsAction = {
  type: typeof ADMIN.REQUEST_CAMPAIGNS,
};

export type ReceiveCampaignsAction = {
  type: typeof ADMIN.RECEIVE_CAMPAIGNS,
  campaigns: Array,
};

export type ReceiveCampaignsErrorAction = {
  type: typeof ADMIN.RECEIVE_CAMPAIGNS_ERROR,
  error: string,
};

export type RequestProductsAction = {
  type: typeof ADMIN.REQUEST_PRODUCTS,
  campaignId: number,
};

export type ReceiveProductsAction = {
  type: typeof ADMIN.RECEIVE_PRODUCTS,
  products: Array,
  variants: Object,
};

export type ReceiveProductsErrorAction = {
  type: typeof ADMIN.RECEIVE_PRODUCTS_ERROR,
  error: string,
};

export type RequestUpdateProductsAction = {
  type: typeof ADMIN.REQUEST_UPDATE_PRODUCTS,
  campaignId: string,
  productsToUpdate: Array,
  rowId: Number,
  updateProductsCallback: Function,
};

export type ReceiveUpdatedProductsAction = {
  type: typeof ADMIN.RECEIVE_UPDATED_PRODUCTS,
  updatedProducts: Array,
};

export type ReceiveUpdatedProductsActionError = {
  type: typeof ADMIN.RECEIVE_UPDATED_PRODUCTS_ERROR,
  error: string,
};

export type RequestAllCategoriesAction = {
  type: typeof ADMIN.REQUEST_ALL_CATEGORIES,
};

export type ReceiveAllCategoriesAction = {
  type: typeof ADMIN.RECEIVE_ALL_CATEGORIES,
  campaigns: Array,
};

export type ReceiveAllCategoriesErrorAction = {
  type: typeof ADMIN.RECEIVE_ALL_CATEGORIES_ERROR,
  error: string,
};

export type RequestCategoriesCampaignAction = {
  type: typeof ADMIN.REQUEST_CATEGORIES_CAMPAIGN,
};

export type ReceiveCategoriesCampaignAction = {
  type: typeof ADMIN.RECEIVE_CATEGORIES_CAMPAIGN,
  campaigns: Array,
};

export type ReceiveCategoriesCampaignErrorAction = {
  type: typeof ADMIN.RECEIVE_CATEGORIES_CAMPAIGN_ERROR,
  error: string,
};

export type RequestUpdateCategoriesAction = {
  type: typeof ADMIN.REQUEST_UPDATE_CATEGORIES,
  campaignId: Number,
  updatedCategories: Array,
  parentId: Number,
  categories: Array,
};

export type ReceiveUpdatedCategoriesAction = {
  type: typeof ADMIN.RECEIVE_UPDATED_CATEGORIES,
  updatedCategories: Array,
};

export type ReceiveUpdatedCategoriesErrorAction = {
  type: typeof ADMIN.RECEIVE_UPDATED_CATEGORIES_ERROR,
  error: string,
};

export function requestUserRoles(): RequestUserRolesAction {
  return {
    type: ADMIN.REQUEST_USER_ROLES,
  };
}

export function receiveUserRoles(roles: Array): ReceiveUserRolesAction {
  return {
    type: ADMIN.RECEIVE_USER_ROLES,
    roles,
  };
}

export function receiveUserRolesError(): ReceiveUserRolesErrorAction {
  return {
    type: ADMIN.RECEIVE_USER_ROLES_ERROR,
  };
}

export function requestCampaigns(): RequestCampaignsAction {
  return {
    type: ADMIN.REQUEST_CAMPAIGNS,
  };
}

export function receiveCampaigns(campaigns: Array): ReceiveCampaignsAction {
  return {
    type: ADMIN.RECEIVE_CAMPAIGNS,
    campaigns,
  };
}

export function receiveCampaignError(): ReceiveCampaignsErrorAction {
  return {
    type: ADMIN.RECEIVE_CAMPAIGNS_ERROR,
  };
}

export function requestProducts(campaignId: Number): RequestProductsAction {
  return {
    type: ADMIN.REQUEST_PRODUCTS,
    campaignId,
  };
}

export function receiveProducts(
  products: Array,
  variants: Object
): ReceiveProductsAction {
  return {
    type: ADMIN.RECEIVE_PRODUCTS,
    products,
    variants,
  };
}

export function receiveProductsError(): ReceiveProductsErrorAction {
  return {
    type: ADMIN.RECEIVE_PRODUCTS_ERROR,
  };
}

export function requestUpdateProducts(
  campaignId: Number,
  productsToUpdate: Array,
  rowId: Number,
  updateProductsCallback: Function
): RequestUpdateProductsAction {
  return {
    type: ADMIN.REQUEST_UPDATE_PRODUCTS,
    campaignId,
    productsToUpdate,
    rowId,
    updateProductsCallback,
  };
}

export function receiveUpdatedProducts(
  updatedProducts: Array,
  variants: Object,
  rowId: Number
): ReceiveUpdatedProductsAction {
  return {
    type: ADMIN.RECEIVE_UPDATED_PRODUCTS,
    updatedProducts,
    variants,
    rowId,
  };
}

export function receiveUpdatedProductsError(
  error: string,
  rowId: Number
): ReceiveUpdatedProductsActionError {
  return {
    type: ADMIN.RECEIVE_UPDATED_PRODUCTS_ERROR,
    error,
    rowId,
  };
}

export function requestAllCategories(): RequestAllCategoriesAction {
  return {
    type: ADMIN.REQUEST_ALL_CATEGORIES,
  };
}

export function receiveAllCategories(
  categories: Array
): ReceiveAllCategoriesAction {
  return {
    type: ADMIN.RECEIVE_ALL_CATEGORIES,
    categories,
  };
}

export function receiveAllCategoriesError(): ReceiveAllCategoriesErrorAction {
  return {
    type: ADMIN.RECEIVE_ALL_CATEGORIES_ERROR,
  };
}

export function requestCategoriesCampaign(
  campaignId: Number
): RequestCategoriesCampaignAction {
  return {
    type: ADMIN.REQUEST_CATEGORIES_CAMPAIGN,
    campaignId,
  };
}

export function receiveCategoriesCampaign(
  categories: Array
): ReceiveCategoriesCampaignAction {
  return {
    type: ADMIN.RECEIVE_CATEGORIES_CAMPAIGN,
    categories,
  };
}

export function receiveCategoriesCampaignError(): ReceiveCategoriesCampaignErrorAction {
  return {
    type: ADMIN.RECEIVE_CATEGORIES_CAMPAIGN_ERROR,
  };
}

export function requestUpdateCategories(
  campaignId: Number,
  updatedCategories: Array,
  parentId: Number,
  categories: Array
): RequestUpdateCategoriesAction {
  return {
    type: ADMIN.REQUEST_UPDATE_CATEGORIES,
    campaignId,
    updatedCategories,
    parentId,
    categories,
  };
}

export function receiveUpdatedCategories(
  updatedCategories: Array,
  parentId: Number
): ReceiveUpdatedCategoriesAction {
  return {
    type: ADMIN.RECEIVE_UPDATED_CATEGORIES,
    updatedCategories,
    parentId,
  };
}

export function receiveUpdatedCategoriesError(
  error: string
): ReceiveUpdatedCategoriesErrorAction {
  return {
    type: ADMIN.RECEIVE_UPDATED_CATEGORIES_ERROR,
    error,
  };
}
